module.exports = __webpack_public_path__ + "media/brand/scribble-orange-5b65ed41.svg";